import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import LockClockIcon from '@mui/icons-material/LockClock';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';

interface IMenuConfigItem {
  index: number;
  name: string;
  path: string;
  desc: string;
  icon?: JSX.Element;
  type: string;
  role: string[];
}
export const MenuConfig: IMenuConfigItem[] = [
  {
    index: 0,
    name: 'User Actions',
    path: '',
    desc: '',
    type: 'divider',
    role: [],
  },
  {
    index: 1,
    name: 'Manage User Trials',
    path: 'dashboard/user/trials',
    desc: 'provide a username and add or remove a trial to that user.',
    icon: <LockClockIcon />,
    type: 'link',
    role: ['SUPPORT', 'ADMIN', 'SUPPORTREADONLY'],
  },
  {
    index: 2,
    name: 'Manage User Feature Access',
    path: 'dashboard/user/softwareaccess',
    desc: 'manage access to various software packages',
    icon: <ManageAccountsIcon />,
    type: 'link',
    role: ['DEV', 'ADMIN'],
  },
  {
    index: 3,
    name: 'Manage User Feature Flags',
    path: 'dashboard/user/featureflags',
    desc: 'manage software packages (such as DEV/RC) for a user',
    icon: <MiscellaneousServicesIcon />,
    type: 'link',
    role: ['DEV', 'ADMIN'],
  },
  {
    index: 4,
    name: 'Account Actions',
    path: '',
    desc: '',
    type: 'divider',
    role: [],
  },
  {
    index: 5,
    name: 'Manage Account Entitlements',
    path: 'dashboard/account/entitlements',
    desc: 'Add / Remove Full Entitlement License from an Account',
    icon: <SupervisorAccountIcon />,
    type: 'link',
    role: ['SUPPORT', 'ADMIN', 'SUPPORTREADONLY'],
  },
  {
    index: 6,
    name: 'Admin Actions',
    path: '',
    desc: '',
    type: 'divider',
    role: [],
  },
  {
    index: 7,
    name: 'Manage GEMS Users',
    path: 'dashboard/admin/users',
    desc: 'Manage GEMS user access and accounts',
    icon: <SupervisorAccountIcon />,
    type: 'link',
    role: ['ADMIN'],
  },
];
